<div>
  <div [hidden]="!loading" class="spinner">
    <div class="sk-spinner sk-spinner-pulse"></div>
  </div>
  <div>
    <ag-grid-angular
      style="width: 100%; height: 100%"
      class="ag-theme-alpine"
      rowSelection="multiple"
      rowHeight="48"
      rowMultiSelectWithClick="false"
      suppressRowClickSelection="true"
      suppressDragLeaveHidesColumns="true"
      suppressMenuHide="true"
      enableCellTextSelection="true"
      [icons]="customIcons"
      [columnDefs]="columnDefs"
      [tooltipShowDelay]="500"
      [defaultColDef]="defaultColDef"
      [paginationPageSize]="paginationPageSize"
      [pagination]="true"
      [suppressPaginationPanel]="true"
      [suppressCellSelection]="true"
      [suppressScrollOnNewData]="true"
      [rowData]="rowData"
      [domLayout]="domLayout"
      [rowClassRules]="rowClassRules"
      [enableCellChangeFlash]="true"
      [cellFadeDelay]="10000"
      [getContextMenuItems]="getContextMenuItems"
      [getMainMenuItems]="getMainMenuItems"
      (columnMoved)="onColumnMoved($event)"
      (columnResized)="onColumnResized($event)"
      (columnVisible)="onColumnVisible($event)"
      (rowSelected)="onRowSelected()"
      (gridReady)="onGridReady($event)"></ag-grid-angular>
  </div>

  <div class="d-flex justify-content-between align-items-center my-15 has-pagination">
    <div class="pagination-left">
      <app-pagination
        *ngIf="totalRowsCount > paginationPageSize"
        [totalItems]="totalRowsCount"
        [(currentPage)]="currentPageNumber"
        (change)="onPageChange($event)"
        [pageSize]="paginationPageSize"></app-pagination>
    </div>

    <div class="d-flex align-items-center justify-content-end pagination-right mt-0_5">
      <span class="pagination-count"
        >Showing {{ totalRowsCount > paginationPageSize ? paginationPageSize : totalRowsCount }} of {{ totalRowsCount }} results</span
      >
      <ul *ngIf="sizes.length" class="pagination">
        <li *ngFor="let size of sizes" [ngClass]="{ active: size === paginationPageSize }">
          <a (keyup.enter)="changeSize($event, size)" tabindex="0" [class.link--lg]="size === 1000" (click)="changeSize($event, size)">{{ size }}</a>
        </li>
      </ul>
    </div>
  </div>
</div>

<ng-template #copyModalTpl let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Test summary</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(true)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <div class="d-flex modal-tabs-vertical">
      <ul class="nav flex-column">
        <div (keyup.enter)="scrollTo(section.id)" tabindex="0" *ngFor="let section of testCaseDetails" (click)="scrollTo(section.id)">
          <a class="nav-link cp" [ngClass]="{ active: currentSection === section.id }">
            <span class="nav-text"> {{ section.title }}</span>
          </a>
        </div>
      </ul>

      <div class="tab-content section-parent" id="parentDiv" scrollSpy [spiedTags]="['DIV']" (sectionChange)="onSectionChange($event)">
        <div *ngFor="let section of testCaseDetails" [id]="section.id" class="section-child">
          <ul class="modal-tab-list modal-tab-table-list">
            <li class="title">{{ section.title }}</li>
            <li *ngFor="let details of section.data">
              <span class="left-col" [innerHTML]="details[0]"></span>
              <span class="right-col" [innerHTML]="details[1]"></span>
            </li>
            <li *ngIf="section.id === 'decodedPdu'" class="note">
              <span
                >Please note that the logic used to decode the PDU here can’t be guaranteed to be exactly the same logic used by the end device to
                retrieve the individual SMS parameters displayed to the end user, such as Sender ID and Text.
              </span>
            </li>
          </ul>
        </div>
        <!-- This below element is needed to have last section in focus when scrolling ... -->
        <div class="section-empty-child"></div>
      </div>
    </div>
  </div>

  <div class="modal-footer pt-15">
    <div class="button-holder d-flex justify-content-between">
      <button class="btn btn-outline-dark" (click)="dialogRef.close(true)">Cancel</button>
    </div>
  </div>
</ng-template>

<ng-template #senderModalTpl let-dialogRef="dialogRef">
  <div class="modal-header">
    <div class="modal-title">
      <h3 class="d-inline-block">Sender ID sent / Sender ID delivered</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(true)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <div class="two-col-box">
      <ul>
        <li>
          <span class="left-col text-neutral-n7">{{ diff.title1 }}</span>
          <span class="right-col" [innerHTML]="diff.value1"></span>
        </li>
        <li>
          <span class="left-col text-neutral-n7">{{ diff.title2 }}</span>
          <span class="right-col" [innerHtml]="diff.value2"></span>
        </li>
        <li *ngIf="diff.senderPduHex">
          <span class="left-col text-neutral-n7">Sender ID delivered in PDU </span>
          <span class="right-col text-error">{{ diff.senderPduHex }} </span>
        </li>
        <li *ngIf="flashCallCallerIdHtml">
          <span class="left-col text-neutral-n7">Caller ID</span>
          <span class="right-col flash-call-caller-id-details">
            <span [innerHTML]="flashCallCallerIdHtml"></span>
            <span class="flash-call-pill"><span class="icon-flash-call-phone"></span>Delivered as flash call</span>
          </span>
        </li>
      </ul>
    </div>
  </div>
  <div class="modal-footer pt-15" *ngIf="flashCallCallerIdHtml">
    <span class="footer-note text-primary">
      The Caller ID contains the Test ID. This gives a strong indication that the SMS was delivered as a flash call instead of an SMS.
    </span>
  </div>
  <div class="modal-footer d-flex justify-content-start align-items-center bg-neutral-n2">
    <div (keyup.enter)="dialogRef.close('viewSummary')" tabindex="0" class="view-summary cp" (click)="dialogRef.close('viewSummary')">
      <span>View test summary <i class="fas fa-chevron-right ps-0_5"></i></span>
    </div>
  </div>
</ng-template>

<ng-template #textModalTpl let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Text sent / Text delivered</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(true)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <div class="two-col-box">
      <ul>
        <li>
          <span class="left-col text-neutral-n7">{{ diff.title1 }}</span>
          <span class="right-col" [innerHTML]="diff.value1"></span>
        </li>
        <li>
          <span class="left-col text-neutral-n7">{{ diff.title2 }}</span>
          <span class="right-col" [innerHTML]="diff.value2"></span>
        </li>
        <li *ngIf="diff.result">
          <span class="left-col text-neutral-n7">Difference</span>
          <span class="right-col" [innerHTML]="diff.result"></span>
        </li>
      </ul>
    </div>
  </div>
  <div class="modal-footer pt-15">
    <ul class="footer-index">
      <li>Not modified</li>
      <li class="error">Added</li>
      <li class="black">Removed</li>
      <li class="accent-a6">Test ID Text</li>
    </ul>
  </div>
  <div class="modal-footer d-flex justify-content-start align-items-center bg-neutral-n2">
    <div (keyup.enter)="dialogRef.close('viewSummary')" tabindex="0" class="view-summary cp" (click)="dialogRef.close('viewSummary')">
      <span>View test summary <i class="fas fa-chevron-right ps-0_5"></i></span>
    </div>
  </div>
</ng-template>

<ng-template #smscModalTpl let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Phone/SMSC</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(true)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <div class="two-col-box">
      <ul>
        <li>
          <span class="left-col text-neutral-n7">Test Number:</span> <span class="right-col">{{ smscData.test.phone }}</span>
        </li>
        <li>
          <span class="left-col text-neutral-n7">Test Number Country:</span>
          <span class="right-col">{{ smscData.test.country }}</span>
        </li>
        <li *ngIf="smscData.smsc.phoneFromPdu; else fullSmscBlock">
          <span class="left-col text-neutral-n7">SMSC in PDU:</span> <span class="right-col">{{ smscData.smsc.phoneFromPdu }}</span>
        </li>
        <ng-template #fullSmscBlock>
          <li>
            <span class="left-col text-neutral-n7">SMSC:</span> <span class="right-col">{{ smscData.smsc.phone }}</span>
          </li>
          <li *ngIf="smscData.smsc.country">
            <span class="left-col text-neutral-n7">SMSC Country:</span>
            <span class="right-col" [ngClass]="{ 'text-sucess': !smscData.isError, 'text-error': smscData.isError }">
              {{ smscData.smsc.country }}
            </span>
          </li>
          <li *ngIf="smscData.smsc.provider">
            <span class="left-col text-neutral-n7">SMSC Provider:</span>
            <span class="right-col" [ngClass]="{ 'text-sucess': !smscData.isError, 'text-error': smscData.isError }">
              {{ smscData.smsc.provider }}
            </span>
          </li>
          <li *ngIf="smscData.smsc.mcc">
            <span class="left-col text-neutral-n7">SMSC MCC:</span>
            <span class="right-col" [ngClass]="{ 'text-sucess': !smscData.isError, 'text-error': smscData.isError }">
              {{ smscData.smsc.mcc }}
            </span>
          </li>
          <li *ngIf="smscData.smsc.mnc">
            <span class="left-col text-neutral-n7">SMSC MNC:</span>
            <span class="right-col" [ngClass]="{ 'text-sucess': !smscData.isError, 'text-error': smscData.isError }">
              {{ smscData.smsc.mnc }}
            </span>
          </li>
        </ng-template>
      </ul>
    </div>
  </div>
  <div class="modal-footer pt-15" *ngIf="smscData.smsc?.country">
    <span class="footer-note text-error-r2" *ngIf="smscData.isError">
      The SMSC does not corresponds to the destination country. This might give an indication that SMS has been delivered via non-direct connection.
    </span>
    <span class="footer-note text-sucess" *ngIf="!smscData.isError">
      The SMSC corresponds to the destination country. This gives an indication that SMS has been delivered via direct connection.
    </span>
  </div>
  <div class="modal-footer d-flex justify-content-start align-items-center bg-neutral-n2">
    <div (keyup.enter)="dialogRef.close('viewSummary')" tabindex="0" class="view-summary cp" (click)="dialogRef.close('viewSummary')">
      <span>View test summary <i class="fas fa-chevron-right ps-0_5"></i></span>
    </div>
  </div>
</ng-template>

<ng-template #connectionModalTpl let-dialogRef="dialogRef">
  @let isSessionNotAvailable = !session && !connectionSpinner;
  <div class="modal-header mb-10">
    <div class="modal-title">
      @if (isSessionNotAvailable) {
        <h3 class="d-inline-block">Session info</h3>
      } @else if (session) {
        <h3 class="d-inline-block">{{ supplier.title }} {{ supplier.routeType }}</h3>
      }
      <button type="button" class="btn-close" (click)="dialogRef.close(true)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body" *ngIf="session">
    <div [hidden]="!connectionSpinner" class="spinner">
      <div class="sk-spinner sk-spinner-pulse"></div>
    </div>
    <div class="two-col-box">
      <ul>
        <li>
          <span class="left-col">ID:</span> <span class="right-col">{{ session.id }}</span>
        </li>
        <li>
          <span class="left-col">Login:</span> <span class="right-col">{{ session.systemId }}</span>
        </li>
        <li>
          <span class="left-col">URI:</span>
          <span class="right-col">
            {{ session.hostIp }}<span *ngIf="session.hostPort">:{{ session.hostPort }}</span>
          </span>
        </li>
        <li>
          <span class="left-col">Throughput (SMS/second):</span>
          <span class="right-col">{{ session.throughput }}</span>
        </li>
        <li>
          <span class="left-col">System type:</span> <span class="right-col">{{ session.systemType }}</span>
        </li>
        <li>
          <span class="left-col">NPI:</span> <span class="right-col">{{ session.dstNpi }}</span>
        </li>
        <li>
          <span class="left-col">TON:</span> <span class="right-col">{{ session.dstTon }}</span>
        </li>
        <li>
          <span class="left-col">Service type:</span>
          <span class="right-col">{{ supplier.serviceType }}</span>
        </li>
        <li *ngIf="isAdmin">
          <span class="left-col">User:</span>
          <span class="right-col">{{ session.user ? session.user.email : '' }}</span>
        </li>
      </ul>
    </div>
  </div>

  @if (isSessionNotAvailable) {
    <div class="modal-body">
      <div class="alert alert-danger">Session information is not available.</div>
    </div>
  }
  <div class="modal-footer pt-15" *ngIf="session && (isAdmin || !session.visibleAll)">
    <div class="button-holder d-flex justify-content-between">
      <button class="btn btn-outline-dark" (click)="dialogRef.close(true)" [routerLink]="['/sessions', session.id]">Edit</button>
    </div>
  </div>
</ng-template>

<ng-template #latencyModalTpl let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Detailed Latency Information</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(true)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <div [hidden]="!latencySpinner" class="spinner">
      <div class="sk-spinner sk-spinner-pulse"></div>
    </div>
    <h4 class="test-number" *ngIf="selectedTestIdForCharts">Test: {{ selectedTestIdForCharts }}</h4>
    <div class="d-flex justify-content-between align-items-stretch my-15 gap-10 graph-container">
      <div *ngIf="smppChartMessageTitle && !smsChartOptions" class="text-center w-100">
        <h4 *ngIf="smppChartMessageTitle">{{ smppChartMessageTitle }}</h4>
        <br />
        <p *ngIf="smppChartMessageDesc">{{ smppChartMessageDesc }}</p>
      </div>
      <div
        *ngIf="smppChartMessageTitle && smsChartOptions"
        class="d-flex flex-column align-items-start justify-content-start w-50">
        <div class="latency-container w-100 flex-grow-1 d-flex align-items-center justify-content-center">
          <div class="text-center">
            <h4>{{ smppChartMessageTitle }}</h4>
            <p *ngIf="smppChartMessageDesc">{{ smppChartMessageDesc }}</p>
          </div>
        </div>
      </div>
      <div *ngIf="!smppChartMessageTitle" class="d-flex flex-column align-items-start justify-content-start w-50">
        <div class="latency-container w-100 flex-grow-1">
          <h3 class="mb-20">SMPP Latency Overview</h3>
          <p>This graph provides a visual representation of SMPP latency details.</p>
          <ul>
            <li class="my-10"><b>Test creation (Position 0):</b> After you click 'Run' and 'Confirm', the moment our system logs the test</li>
            <li class="my-10"><b>submit_sm (SMS Submission):</b> The moment our system sends the SMS to your platform</li>
            <li class="my-10">
              <b>submit_sm response (SMS Acceptance/Rejection):</b> The moment we get notified of your platform accepting or rejecting the SMS
            </li>
            <li class="my-10">
              <b>deliver_sm timestamp (DLR Received):</b> The moment our system gets the Delivery Report (DLR) from your platform.
            </li>
          </ul>
          <br />
          <div class="mt-20 highcharts-container" [class.mb-20]="!smppResponseUnavailable">
            <highcharts-chart
              *ngIf="!smppChartMessageTitle"
              [Highcharts]="Highcharts"
              [options]="smppChartOptions"
              style="width: 100%; height: 200px; display: block">
            </highcharts-chart>
          </div>
          <p *ngIf="smppResponseUnavailable" class="text-center text-neutral-n7 -mt-15 mb-15">No submit_sm response received before timeout</p>
          <div class="note">
            <span
              >Note: These times will slightly differ from your system timestamps due to network latency. This feature could be useful to assess such
              latency.
            </span>
          </div>
          <br />
        </div>
      </div>

      <div
        *ngIf="!smppChartMessageTitle || smsChartOptions"
        class="d-flex flex-column align-items-start justify-content-start w-50">
        <div class="latency-container w-100 flex-grow-1">
          <h3 class="mb-20">Received Status Latency Overview</h3>
          <p>This graph presents three types of timestamps to help you track the lifecycle of a <b>received </b>SMS message.</p>
          <ul>
            <li class="my-10"><b>Test creation (Position 0):</b> After you click 'Run' and 'Confirm', the moment our system logs the test</li>
            <li class="my-10"><b>SMSC Timestamp:</b> The moment of SMS submission by SMSC, according to the GSM SMS PDU received on the phone</li>
            <li class="my-10">
              <b>Received on Phone:</b> The moment the SMS was delivered to the user's phone (may be unreliable in cases when the time/timezone
              settings of the phone are incorrect)
            </li>
            <li class="my-10">
              <b>Received on Server:</b> The moment our server gets the SMS reception notification from the phone, used as the official SMS received
              time and for Rec. delay calculation
            </li>
          </ul>
          <div class="my-20 highcharts-container">
            <highcharts-chart
              *ngIf="smsChartOptions && !smsChartMessageTitle"
              [Highcharts]="Highcharts"
              [options]="smsChartOptions"
              style="width: 100%; height: 200px; display: block">
            </highcharts-chart>
          </div>
          <div class="note">
            <span
              >Note: ‘SMSC Timestamp' and 'Received on Phone' can be unreliable if the device time settings are off. If significant discrepancies or
              reception order issues are detected, this graph won’t be displayed to avoid confusion.
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #commentModalTpl let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Comment</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(true)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <app-test-result-comment [model]="commentModel" (onAfterSave)="onAfterSaveComment()"></app-test-result-comment>
</ng-template>

<ng-template #reimburseModalTpl let-dialogRef="dialogRef">
  <confirm-modal [dialogRef]="dialogRef"></confirm-modal>
</ng-template>

<app-phone-report-widget (phoneReportCreate)="onAfterPhoneReportCreate($event)"></app-phone-report-widget>
